import React from "react"
import { latest as API_URL } from '../config/api';
import axios from 'axios';
//import Slider from "react-slick";
//https://jsfiddle.net/marvelousowl/jtccpz6a/

let timeouts = {};

const postUrlSidebarCatalogs  = API_URL + 'sidebar-catalogs';

class FiltersActive extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            module_menu_show : "hide-panel",
            panel_menu_show : "hide-panel",
            prev_slide : 0,
            filter_proper_active : "hide",
            filters_group : {},
            filters_items : {}
        };
    }
    componentWillMount(){
        const qs = require('qs');
        let self = this;
        axios.post(postUrlSidebarCatalogs,  qs.stringify({ api_token: localStorage.getItem("api_token") }))
        .then(function (response){ 
            self.setState({
                catalogs_active : response.data
            }, function(){
                let catalogs_active = this.state.catalogs_active;

                Object.keys(catalogs_active).map(function(key){
                    if(catalogs_active[key].id !== "tariff_type"){
                        self.state.filters_group[catalogs_active[key].id] = { 
                            name : catalogs_active[key].name['en'],
                            show : "hide" 
                        }
                    }
                })
                self.state.filters_group['time'] = { show : "hide" }
                //self.props.app.state.filters_apply['property'] = []
            })
        })
    }
    
    removeFilterActive(type, value){
        this.props.app.setFiltersQuick(value, type)
    }

    filterState(key, items){
        if(items.length > 3){
            return this.state.filters_group[key].show;
        }else{ 
            return "";
        }
    }
    setGroupState(key, action){
        let filters_group = this.state.filters_group;
        
        if(action === "default"){
            filters_group[key].show = "fade in";
            this.setState({
                filters_group : filters_group
            })
        }else if(action === "close"){
            filters_group[key].show = "hide";
            this.setState({
                filters_group : filters_group
            })
        }
    }
    render(){
        let self = this, number_filters = 0;
        let time_filters = this.props.app.state.current_filter_time;        
        const listItemsTime = Object.keys(time_filters).map((key) =>
            <div key={"timeparent-" + key} className="filter-apply">
                <span key={"timechild-" + key} className="description-filter">{time_filters[key].time}</span>
                { 
                    this.props.app.state.mode_report._is_invited === false ? 
                    (<a 
                        className="remove-item" 
                        key={time_filters[key].value} 
                        onClick={this.removeFilterActive.bind(this, "time", time_filters[key].value)}
                    />) : null
                }
            </div>
        );
        
        let filters_group = self.state.filters_group,
            filters_apply = self.props.app.state.filters_apply;
        
        let filters_bubble = Object.keys(filters_group).map((key_group) => {
            let group_filter_apply = 
                (typeof(filters_apply[key_group]) !== "undefined" && key_group !== 'time') ? 
                filters_apply[key_group] : {};

            let listItems = Object.keys(group_filter_apply).map(function(key_filter){
                number_filters++;
                return (
                    <div key={key_group + "-" + key_filter} className="filter-apply">
                        <span key={key_group + "-child-" + key_filter} className="description-filter">{group_filter_apply[key_filter].name}</span>
                        { 
                            self.props.app.state.mode_report._is_invited === false ? 
                            (<a 
                                className="remove-item"
                                key={group_filter_apply[key_filter].value} 
                                onClick={self.removeFilterActive.bind(self, key_group, group_filter_apply[key_filter])}
                            />) : null
                        }
                    </div>    
                );
            });
            return (Object.keys(group_filter_apply).length > 0) ?
                (<div className={"filter-bubble " + (Object.keys(group_filter_apply).length > 0 ? "" : "hide") }>
                    <span className={"title " + (self.filterState(key_group, Object.keys(group_filter_apply)) === "hide" ? "box-type" : "")}>
                        { filters_group[key_group].name }
                        { 
                            self.filterState(key_group, Object.keys(group_filter_apply)) === "hide" ? 
                                <span> ({Object.keys(group_filter_apply).length}) <span className="show-filters-active" onClick={self.setGroupState.bind(this,key_group, "default")} /> </span> :
                                ""
                        }
                        { 
                            self.filterState(key_group, Object.keys(group_filter_apply)) !== "hide" ? 
                            <span className={"hide-filters-active " + (Object.keys(group_filter_apply).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this,key_group, "close")} />
                            : ""
                        }
                    </span>
                    <div 
                        className={"content-filters " + this.filterState(key_group, Object.keys(group_filter_apply))} 
                        onMouseLeave={this.setGroupState.bind(this, key_group, "leave")}
                        onMouseEnter={this.setGroupState.bind(this, key_group, "enter")} 
                        children={listItems}
                        />
                </div>) : ""
            
            /*  let catalog_filter = filters_group[key]
            console.log(catalog_filter)
            self.state.filters_items[key] = Object.keys(catalog_filter).map(function(key_catalog){
                return (
                    <div key={"planparent-" + key} className="filter-apply">
                        <span key={"planchild-" + key} className="description-filter">{plan[key].plan}</span>
                        { 
                            this.props.app.state.mode_report._is_invited === false ? 
                            (<a 
                                className="remove-item"
                                key={plan[key].value} 
                                onClick={this.removeFilterActive.bind(this, key_catalog, catalog_filter[key_catalog].value)}
                            />) : null
                        }
                    </div>    
                );
            }); */
        });
        
        self.props.app.state.number_filters = number_filters;
        return(
            <section id="container-filters-active" className={"filters-active "}>
                {
                    this.props.app.state.show_time_compare === true ? 
                        <div className={"filter-bubble " + (Object.keys(time_filters).length > 0 ? "" : "hide") }>
                            <span className={"title " + (this.filterState("time", Object.keys(listItemsTime)) === "hide" ? "box-type" : "")}>
                                {this.props.app.state.panel === "lead-time" ? "INTERVALO DE TIEMPO" : " COMPARATIVE TIME" }
                                { 
                                    this.filterState("time", Object.keys(listItemsTime)) === "hide" ? 
                                        <span> ({Object.keys(listItemsTime).length}) <span className="show-filters-active" onClick={this.setGroupState.bind(this, "time", "default")} /> </span> :
                                        ""
                                }
                                { 
                                    this.filterState("time", Object.keys(listItemsTime)) !== "hide" ? 
                                    <span className={"hide-filters-active " + (Object.keys(listItemsTime).length < 4 ? "hide" : "" )} onClick={this.setGroupState.bind(this, "time", "close")} />
                                    : ""
                                }
                            </span>
                            <div 
                                className={"content-filters " + this.filterState("time", Object.keys(listItemsTime))} 
                                onMouseLeave={this.setGroupState.bind(this, "time", "leave")}
                                onMouseEnter={this.setGroupState.bind(this, "time", "enter")}>
                                
                                {listItemsTime}
                            </div>
                        </div>
                    : ""
                }
        
                {filters_bubble}
                
            </section>
        )
    }
};
export default FiltersActive



// WEBPACK FOOTER //
// ./src/Frontend/components/FiltersActive.js